export default __webpack_public_path__ + "static/landscapes-a34162df9d8228fc21e543c99a67d500.webp";